module.exports = __webpack_public_path__ + "img/homepage_05.8e231fe1.jpg";